"use client";

import { useFormGroup } from "../__chunks/DAP7HNKY.js";
import "../__chunks/36LIF33V.js";
import "../__chunks/7HVFURXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/form/form-radio-group.tsx
var TagName = "div";
var useFormRadioGroup = createHook(function useFormRadioGroup2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  props = __spreadValues({
    role: "radiogroup"
  }, props);
  props = useFormGroup(props);
  return props;
});
var FormRadioGroup = forwardRef(function FormRadioGroup2(props) {
  var htmlProps = useFormRadioGroup(props);
  return createElement(TagName, htmlProps);
});
export { FormRadioGroup, useFormRadioGroup };